export function isEventAdmin(currentUser, isAnAdmin, selectedEvent) {
  if (isAnAdmin) return true;
  if (!currentUser || !selectedEvent) return false;

  return selectedEvent.admins?.includes(currentUser.id);
}
